module.exports = __webpack_public_path__ + "img/idi-logo.136f5d1c.png";